import { router } from "../router/Router";
import { invokeHTTPRequest } from "./network";

export function disableKeyBoardSave(targetElem, useCapture = false) {
    if (!targetElem) { return; }
    targetElem.addEventListener('keydown', function (evt) {
        evt = evt || window.event;
        if (evt.ctrlKey || evt.metaKey) {
            if (evt.key === 's') { //ctrl + s
                evt.preventDefault();
            }
        }
    }, useCapture);
}

export function fetchApps() {
    return new Promise((resolve, reject) => {
        Promise.allSettled([
            invokeHTTPRequest(`${router.appPrefix}/static/apps.base.json`),
            invokeHTTPRequest(`${router.appPrefix}/static/apps.json`)])
            .then(values => {
                resolve(parseApps(values));
            })
            .catch(err => {
                reject(err);
            });
    });
}
function parseApps(values) {
    const appsMap = new Map();
    values.forEach((res) => {
        if (res.status === 'fulfilled' && Array.isArray(res.value)) {
            res.value.forEach(app => {
                appsMap.set(app.name, { ...appsMap.get(app.name), ...app });
            });
        }
    });
    return Array.from(appsMap.values()).filter(app => !app.hidden || app.accessible);    
}

export function overrideStorageAPI(window, prefix) {
    if (!window || !prefix) return;

    const script = document.createElement('script');
    script.textContent = `
        (function() {
            const localStorageSetItem = localStorage.setItem;
            const localStorageGetItem = localStorage.getItem;
            const localStorageRemoveItem = localStorage.removeItem;
            const localStorageKey = localStorage.key;
            const sessionStorageSetItem = sessionStorage.setItem;
            const sessionStorageGetItem = sessionStorage.getItem;
            const sessionStorageRemoveItem = sessionStorage.removeItem;
            const sessionStorageKey = sessionStorage.key;
            
            const EXCLUDED_KEYS_PREFIX = ["theia:"];
            const prefix = "__${prefix}__";
            const NO_VALUE = "__NO_VALUE__";

            localStorage.setItem = function(key, value) {
                return invokeStorageMethod(this, localStorageSetItem, key, value);
            };

            localStorage.getItem = function(key) {
                return invokeStorageMethod(this, localStorageGetItem, key);
            };

            localStorage.removeItem = function(key) {
                return invokeStorageMethod(this, localStorageRemoveItem, key);
            };

            localStorage.key = function(index) {
                return invokeStorageKeyMethod(this, localStorageKey, index);
            };

            sessionStorage.setItem = function(key, value) {
                return invokeStorageMethod(this, sessionStorageSetItem, key, value);
            };

            sessionStorage.getItem = function(key) {
                return invokeStorageMethod(this, sessionStorageGetItem, key);
            };

            sessionStorage.removeItem = function(key) {
                return invokeStorageMethod(this, sessionStorageRemoveItem, key);
            };

            sessionStorage.key = function(index) {
                return invokeStorageKeyMethod(this, sessionStorageKey, index);
            };

            function invokeStorageMethod(self, storageFunc, key, value = NO_VALUE) {
                if (EXCLUDED_KEYS_PREFIX.some(excluded => key.startsWith(excluded))) {
                    return value === NO_VALUE ? storageFunc.call(self, key) : storageFunc.call(self, key, value);
                }
                return value === NO_VALUE ? storageFunc.call(self, prefix + key) : storageFunc.call(self, prefix + key, value);
            }

            function invokeStorageKeyMethod(self, storageFunc, index) {
                const key = storageFunc.call(self, index);
                if (key && key.startsWith(prefix)) {
                    return key.slice(prefix.length);
                }
                return key;
            }
        })();
    `;
    window.document.head.appendChild(script);
}